import { render } from "./DeleteUser.vue?vue&type=template&id=29a802df&scoped=true"
import script from "./DeleteUser.vue?vue&type=script&lang=js"
export * from "./DeleteUser.vue?vue&type=script&lang=js"

import "./DeleteUser.vue?vue&type=style&index=0&id=29a802df&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29a802df"

export default script